import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FileText, Calendar } from 'lucide-react';
import { issueService } from '../services/api';

function Issues() {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIssues = async () => {
      try {
        const response = await issueService.getAll();
        setIssues(response.data);
      } catch (err) {
        setError('خطا در بارگذاری شماره‌ها');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchIssues();
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">شماره‌های نشریه</h1>
          <p className="text-xl text-blue-100">تمام انتشارات نشریه مجری</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        {loading && <div className="text-center py-12 text-gray-500">در حال بارگذاری...</div>}
        {error && <div className="bg-red-100 text-red-700 p-4 rounded-lg mb-8">{error}</div>}

        {!loading && issues.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            هیچ شماره‌ای برای نمایش وجود ندارد
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {issues.map((issue) => (
            <Link
              key={issue.id}
              to={`/issues/${issue.id}`}
              className="bg-white rounded-xl shadow-md hover:shadow-xl transition overflow-hidden group"
            >
              <div className="bg-gradient-to-br from-blue-700 to-blue-900 text-white p-8 group-hover:from-blue-800 group-hover:to-blue-950 transition">
                <div className="text-6xl font-bold mb-2 text-blue-100">{issue.volume}</div>
                <p className="text-blue-200 font-semibold">جلد {issue.volume} - شماره {issue.number}</p>
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-3 group-hover:text-blue-700 transition">{issue.title}</h3>
                <p className="text-gray-600 text-sm mb-6 line-clamp-3 leading-relaxed">{issue.description}</p>
                <div className="flex items-center justify-between text-sm text-gray-500 pt-4 border-t border-gray-200">
                  <span className="flex items-center gap-2">
                    <FileText size={16} className="text-blue-600" />
                    {issue.articles?.length || 0} مقاله
                  </span>
                  <span className="flex items-center gap-2">
                    <Calendar size={16} className="text-blue-600" />
                    {new Date(issue.publicationDate).toLocaleDateString('fa-IR')}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Issues;
